import linealFeetItemState from "@/components/Order/OrderItemsLinealFeetLengths/additional-products-wrapper.reducer";
import linealMeterItemState from "@/components/Order/OrderItemsLinealMeterLengths/additional-products-wrapper.reducer";
import squareFeetItemState from "@/components/Order/OrderItemsSquareFeetLengths/additional-products-wrapper.reducer";
import squareMeterItemState from "@/components/Order/OrderItemsSquareMeterLengths/additional-products-wrapper.reducer";
/**
 * Wrapper creators for the additional-products slice. Each handles its own action types
 * in isolation without adding logic to the large additional-products.js module.
 * Order does not matter since each wrapper only handles its own actions.
 * To add a new component wrapper: add the import and append to this array.
 */
const ADDITIONAL_PRODUCTS_WRAPPER_CREATORS = [
  linealFeetItemState,
  linealMeterItemState,
  squareFeetItemState,
  squareMeterItemState,
];

/**
 * Composes all additional-products wrapper reducers so that component-specific
 * actions are handled in isolation.
 *
 * @param {Function} originalReducer - additionalProducts.reducers
 * @returns {Function} Composed reducer for the additionalProducts slice
 */
export default function createAdditionalProductsWrapper(originalReducer) {
  return ADDITIONAL_PRODUCTS_WRAPPER_CREATORS.reduceRight(
    (reducer, createWrapper) => createWrapper(reducer),
    originalReducer
  );
}
